import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { CartProvider } from "@/lib/cart";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Search from "@/pages/Search";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import PhotographerLogin from "@/pages/PhotographerLogin";
import PhotographerRegister from "@/pages/PhotographerRegister";
import PhotographerDashboard from "@/pages/PhotographerDashboard";
import PhotographerUpload from "@/pages/PhotographerUpload";
import Receipt from "@/pages/Receipt";
import Sponsorship from "@/pages/Sponsorship";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PhotographerProfile from "@/pages/PhotographerProfile";
import PhotographerCreateEvent from "@/pages/PhotographerCreateEvent";
import PublicPhotographerProfile from "@/pages/PublicPhotographerProfile";
import EventPage from "@/pages/EventPage";
import EventManage from "@/pages/EventManage";
import PhotographerOrders from "@/pages/PhotographerOrders";

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/search" element={<Search />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/receipt/:orderId" element={<Receipt />} />
            <Route path="/sponsring" element={<Sponsorship />} />
            <Route path="/photographer/login" element={<PhotographerLogin />} />
            <Route path="/photographer/register" element={<PhotographerRegister />} />
            <Route path="/photographer/dashboard" element={<PhotographerDashboard />} />
            <Route path="/photographer/upload" element={<PhotographerUpload />} />
            <Route path="/photographer/profile" element={<PhotographerProfile />} />
            <Route path="/photographer/orders" element={<PhotographerOrders />} />
            <Route path="/photographer/events/new" element={<PhotographerCreateEvent />} />
            <Route path="/photographer/events/:id/manage" element={<EventManage />} />
            <Route path="/fotograf/:slug" element={<PublicPhotographerProfile />} />
            <Route path="/event/:slug" element={<EventPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" />
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
